const home = {
  'hero.eyebrow': 'Centro de recursos USFans',
  'hero.title': 'USFans Spreadsheet — Encuentra productos, vendedores y recursos de compra más rápido',
  'hero.subtitle': 'Explora los recursos de la hoja de cálculo de USFans, listas de productos, información de vendedores, reseñas, guías de envío y recursos prácticos de compra en un solo lugar organizado.',
  'hero.primaryCta': 'USFans Spreadsheet',
  'hero.secondaryCta': 'Comprar Ahora',
  'hero.trust': 'Recurso independiente • Actualizado periódicamente • Creado para facilitar la investigación de productos',

  'category.browse': 'Explorar categorías',
  'category.label': 'Elige una categoría',
  'category.all': 'Todas las categorías',
  'category.hint': 'Salta directamente a una categoría de productos en el sitio web principal.',

  'categories.shoes': 'Zapatos',
  'categories.hoodies': 'Sudaderas / Suéteres',
  'categories.tshirts': 'Camisetas',
  'categories.jackets': 'Chaquetas',
  'categories.pants': 'Pantalones / Shorts',
  'categories.headwear': 'Gorros y gorras',
  'categories.sets': 'Conjuntos',
  'categories.underwear': 'Ropa interior',
  'categories.jersey': 'Camisetas deportivas',
  'categories.accessories': 'Accesorios',
  'categories.bags': 'Bolsos',
  'categories.belts': 'Cinturones',
  'categories.perfumes': 'Perfumes',
  'categories.other': 'Otras cosas',

  'whatis.title': '¿Qué es una hoja de cálculo de USFans?',
  'whatis.copy': 'Una hoja de cálculo de USFans puede ayudarte a organizar la información de productos, los recursos de vendedores y referencias útiles de compra en un solo lugar. Nuestro objetivo es facilitar la investigación de productos organizando los recursos relevantes de USFans en categorías, guías y comparaciones con capacidad de búsqueda.',
  'whatis.cta': 'Explorar el centro de hojas de cálculo',

  'why.title': 'Todo lo que necesitas para una investigación USFans más inteligente',
  'why.subtitle': 'Recursos organizados diseñados para ayudarte a investigar productos y vendedores con más confianza.',
  'why.card1.title': 'USFans Spreadsheet',
  'why.card1.desc': 'Encuentra recursos organizados de productos y vendedores en un solo lugar.',
  'why.card2.title': 'Directorio de vendedores',
  'why.card2.desc': 'Explora información relacionada con vendedores y guías de investigación.',
  'why.card3.title': 'Guías de productos',
  'why.card3.desc': 'Descubre consejos de investigación específicos por categoría.',
  'why.card4.title': 'Reseñas de USFans',
  'why.card4.desc': 'Comprende los factores importantes antes de usar un servicio o recurso.',
  'why.card5.title': 'Guías de envío',
  'why.card5.desc': 'Aprende sobre costos, métodos y consideraciones comunes de envío.',
  'why.card6.title': 'Centro de seguridad',
  'why.card6.desc': 'Aprende a identificar enlaces, ofertas y riesgos sospechosos.',

  'popular.title': 'Búsquedas populares de USFans',
  'popular.subtitle': 'Explora los temas que más busca la gente al investigar recursos de USFans.',
  'popular.1': 'Reseña de USFans',
  'popular.2': 'Costo de envío de USFans',
  'popular.3': 'Cupón de USFans',
  'popular.4': 'Código de descuento de USFans',
  'popular.5': 'Almacén de USFans',
  'popular.6': '¿USFans es legítimo?',
  'popular.7': 'USFans Spreadsheet',
  'popular.8': 'Guía de vendedores de USFans',

  'compare.title': 'Compara los recursos de USFans antes de decidir',
  'compare.subtitle': 'Una referencia rápida para entender para qué sirve cada recurso. Nunca inventamos valoraciones, precios ni afirmaciones de verificación.',
  'compare.col.resource': 'Recurso',
  'compare.col.category': 'Categoría',
  'compare.col.info': 'Para qué sirve',
  'compare.row1.resource': 'USFans Spreadsheet',
  'compare.row1.category': 'Investigación',
  'compare.row1.info': 'Organización de información de productos y vendedores',
  'compare.row2.resource': 'Directorio de vendedores',
  'compare.row2.category': 'Vendedores',
  'compare.row2.info': 'Guía de investigación y verificación de vendedores',
  'compare.row3.resource': 'Guías de productos',
  'compare.row3.category': 'Productos',
  'compare.row3.info': 'Consejos de investigación de productos por categoría',
  'compare.row4.resource': 'Guías de envío',
  'compare.row4.category': 'Envío',
  'compare.row4.info': 'Métodos, costos y consideraciones de envío',
  'compare.row5.resource': 'Centro de seguridad',
  'compare.row5.category': 'Seguridad',
  'compare.row5.info': 'Conciencia de riesgos y navegación segura',

  'article.faqTitle': 'Preguntas frecuentes',
  'guides.title': 'Guías y tutoriales de USFans',
  'guides.subtitle': 'Guías originales y detalladas para ayudarte a investigar productos y vendedores de forma más eficaz.',
  'guides.updated': 'Actualizado',
  'guides.minRead': 'min de lectura',
  'guides.category.guide': 'Guía',
  'guides.category.review': 'Reseña',
  'guides.category.shipping': 'Envío',

  'safety.title': 'Mantente más seguro al investigar recursos de USFans',
  'safety.copy': 'Verifica siempre de forma independiente los sitios web, vendedores, enlaces, información de pago y detalles de los productos. Nuestro Centro de Seguridad explica los riesgos comunes, incluyendo sitios sospechosos, enlaces de phishing, promociones engañosas y prácticas de navegación inseguras.',
  'safety.cta': 'Visitar el Centro de Seguridad',
  'safety.point1': 'Verifica sitios y enlaces de forma independiente',
  'safety.point2': 'Nunca compartas datos de pago o cuenta sin cuidado',
  'safety.point3': 'Cuidado con promociones engañosas y ofertas falsas',
  'safety.point4': 'Investiga a los vendedores antes de decidir',

  'final.title': '¿Listo para explorar USFans Spreadsheet?',
  'final.copy': 'Comienza con el centro de USFans Spreadsheet, compara recursos útiles y explora guías prácticas diseñadas para que tu investigación sea más rápida y fácil.',
  'final.cta': 'Explorar USFans Spreadsheet',
  'final.secondary': 'Visitar sitio principal',
};

export default home;